import React, { PropTypes } from 'react';
import { equals, subtract, ifElse, call } from 'ramda';

const PageInDicatorDots = props => {
  const {
    numberOfIndicators,
    activeIndicator,
    hide,
  } = props;

  const renderIndicator = page => {
    return (
      <span
        key={page}
        className="tc-icon-fiber_manual_record"
        style={{ marginLeft: '5px', color: equals(page, subtract(activeIndicator, 2)) ? '#757575' : '#cccccc', fontSize: '8px' }}
      >
      </span>
    );
  };

  const indicators = [];
  for (let i = 0; i < numberOfIndicators; i++) {
    indicators.push(renderIndicator(i));
  }

  return (
    <div>
      {
        hide ? <div /> :
          <div style={{ marginTop: '10px' }}>
            {indicators}
          </div>
      }
    </div>
  );
};

PageInDicatorDots.propTypes = {
  hide: PropTypes.bool,
  numberOfIndicators: PropTypes.number,
  activeIndicator: PropTypes.number,
};

export default PageInDicatorDots;



// WEBPACK FOOTER //
// ./src/app/components/signup/page-indicator-dots.jsx